import { MRT_ColumnDef, MaterialReactTable } from "material-react-table"
import { useAppSelector } from "../../../redux/hooks"
import { Box, SxProps, TableCellProps } from "@mui/material"
import { defaultTableProps } from "../ResourceBudgetTable/constants"

type tableProps = {
  columns: MRT_ColumnDef<any>[]
  data: {}[]
  pinningCols?: string[]
  containderStyles?: SxProps
  headCellProps?: TableCellProps
  bodyCellProps?: TableCellProps
  bodyCellStyles?: SxProps
}

export const AuditTable = (props: tableProps) => {
  const { columns, data, pinningCols, containderStyles } = props
  const { headCellProps, bodyCellProps, bodyCellStyles } = props
  const loading = useAppSelector((state) => state.app.loading)

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        position: "relative",
      }}
    >
      <MaterialReactTable
        columns={columns}
        data={data}
        {...defaultTableProps}
        muiTableHeadCellProps={{
          align: "center",
          sx: {
            backgroundColor: "#3366D6",
            color: "#fff",
            fontWeight: "bold",
            height: "32px",
            border: "0.5px solid #E4E4E4",
            boxShadow: " #00000022 1.95px  0px 2.6px",
          },
          ...headCellProps,
        }}
        muiTableBodyCellProps={{
          align: "center",
          sx: {
            height: "48px",
            border: "0.5px solid #E4E4E4",
            boxShadow: "#00000022 1.95px 0px 2.6px",
            color: "black",
            ...bodyCellStyles,
          },
          ...bodyCellProps,
        }}
        muiTableContainerProps={{
          sx: {
            borderRadius: "none",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            position: "absolute",
            borderBottomRightRadius: "4px",
            borderBottomLeftRadius: "4px",
            ...containderStyles,
          },
        }}
        state={{
          isLoading: loading,
          columnPinning: {
            left: pinningCols,
          },
        }}
      />
    </Box>
  )
}
